import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Grid, Typography, Paper } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import logo from '../assets/images/cards/Chinmaya-Mission-Logo.gif';

export default function BalaviharHistory() {

    const { accessToken, signOut } = useAuth();
    const API_URL = process.env.REACT_APP_API_URL;
    const [bvmembershipHistory, setMembershipHistory] = useState();
    const [bvsessionHistory, setBvsessionHistory] = useState();

    
    //console.log("Balavihar History :", accessToken);

    
    useEffect(() => {
        if (accessToken) {
          BalaviharMembershipHistoryFetch();
        }
      }, [accessToken]);
    
      const BalaviharMembershipHistoryFetch = async () => {
      let response, data;
      try {    
        const response = await fetch(`${API_URL}/gquery`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-cmdfw-jwt-token': `${accessToken}`,
          },
            body: JSON.stringify({
                query: `
                        query {
                          bvHistory {
                            memberships  {
                                membershipId
                                startDate
                                endDate
                                status
                                notes
                                bvYear
                                createdAt 
                                createdBy 
                                membershipTypesEntity{
                                    membershipTypeId
                                    name
                                    startDate
                                    endDate
                                }
                                transactionEntity {
                                    transactionId
                                    eventTypesEntity {
                                        eventTypeId
                                        name
                                        eventYear
                                    }
                                    totalAmount
                                    paymentStatus
                                    createdAt 
                                    createdBy 
                                }
                            }
                            registeredSessions{
                                bvRegistrationId
                                regStartDate
                                regEndDate
                                status
                                memberEntity{
                                    firstName
                                    lastName
                                    fullName
                                }
                                sessionEntity {
                                    sessionId
                                    center
                                    sessionName
                                }
                                gradeEntity{
                                    gradeId
                                    grade
                                }
                            }
                          }
                        }
                      `,
          }),
        });
  
        const data = await response.json();
        if (response.ok) {
          setMembershipHistory(data.data.bvHistory.memberships);
          setBvsessionHistory(data.data.bvHistory.registeredSessions);
        } else {
          if (response.status === 403) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'OTP expired');
            handleLogout(); // Logout user
          } else {
            if (!response.ok) {
              const errorData = await response.json();
              throw new Error(errorData.message || 'Membership fetch failed');
            }
          }
        }
      } catch (error) {
        console.error("Error fetching Balavihar History :", error);
        //signOut();
        //navigate('/');
      }
    };    
    const handleLogout = () => {
      signOut();
      //navigate('/');
    };
    
  return (
    
    <Grid container alignItems="center" >

        <Paper elevation={3}>
            <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
            <Typography variant="h7" align="left" gutterBottom>
                <b>Balavihar Membership History</b>
            </Typography>
            </Paper>
            <div><br /></div>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 250 }} aria-label="simple table">
        <TableHead>
          <TableRow style={{ backgroundColor: '#1976d2', color: 'white' }}>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Membership Type</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }} >Balavihar Year</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Membership Stauts</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Total Amount Paid</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Membership Start Date</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Membership End Date</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Transaction Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bvmembershipHistory && bvmembershipHistory.map((row) => (
            <TableRow
              key={row.transactionId}
            >
              <TableCell align="right">{row.membershipTypesEntity.name}</TableCell>
              <TableCell align="right">{row.bvYear}</TableCell>
              <TableCell align="right">{row.status}</TableCell>
              <TableCell align="right">{row.transactionEntity.totalAmount}</TableCell>
              <TableCell align="right">{row.startDate}</TableCell>
              <TableCell align="right">{row.endDate}</TableCell>
              <TableCell align="right">{row.createdAt}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <div><br /></div>
    <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
      <Typography variant="h7" align="left" gutterBottom>
        <b>Balavihar Session History</b>
      </Typography>
    </Paper>
    <div><br /></div>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 250 }} aria-label="simple table">
        <TableHead>
          <TableRow style={{ backgroundColor: '#1976d2', color: 'white' }}>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Session Name</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Balavihar Year</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Student Name</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Grade</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Status</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Session Start Date</TableCell>
            <TableCell align="right" sx={{ color: "white", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>Session End Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bvsessionHistory && bvsessionHistory.map((row) => (
            <TableRow
              key={row.transactionId}
            >
              <TableCell align="right">{row.sessionEntity.sessionName}</TableCell>
              <TableCell align="right">2025</TableCell>
              <TableCell align="right">{row.memberEntity.fullName}</TableCell>
              <TableCell align="right">{row.gradeEntity.grade}</TableCell>
              <TableCell align="right">{row.status}</TableCell>
              <TableCell align="right">{row.regStartDate}</TableCell>
              <TableCell align="right">{row.regEndDate}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Paper>
    </Grid>
  );
}
